import PropTypes from 'prop-types';
import ListItem from '@mui/material/ListItem';

const MarkdownListItemRenderer = ({ children }) => (
	<ListItem sx={{ display: 'list-item', py: 0 }}>{children}</ListItem>
);

MarkdownListItemRenderer.propTypes = {
	children: PropTypes.node.isRequired,
};

export default MarkdownListItemRenderer;
